<template>
  <div class="home" id="rootchart" :style="cssVars">
    <!-- <div class="title"> -->
    <!--  <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="自选REITs" name="first"> </el-tab-pane>
      <el-tab-pane label="自选REITs表现" name="second"> </el-tab-pane>
    </el-tabs> -->
    <div class="page-content-wrap">
      <div
        class="icon-buton"
        :class="{
          show: show_left,
          'el-icon-arrow-left': show_left,
          'el-icon-arrow-right': !show_left,
        }"
        @click="toggleLeft"></div>
      <div class="left" :class="{ show: show_left }">
        <Left
          v-show="show_left"
          ref="leftNav"
          :nav_list.sync="nav_list"
          @toggleCreateDialog="toggleCreateDialog" />
      </div>
      <div class="right" :class="{ show: show_left }">
        <div class="dfhdszds">
          <CButtons
            :dButtons1="select_1"
            :dButtons1_current="select_1_default"
            @Cbtns_sep="select1Change" />
        </div>
        <Right1
          v-if="select_1_default === '自选REITs'"
          @loadGroups="loadGroups"
          :nav_list.sync="nav_list"
          @toggleCreateDialog="toggleCreateDialog" />
        <Right2
          v-if="select_1_default === '自选REITs表现' && Object.keys(default_config).length"
          @loadGroups="loadGroups"
          :nav_list.sync="nav_list"
          :default_config.sync="default_config" />
      </div>
    </div>
    <!-- </div> -->
    <CreateGroup :nav_list.sync="nav_list" @loadGroups="loadGroups" :show.sync="dialogVisible" />
  </div>
</template>

<script>
import Left from './Left.vue';
import Right1 from './right';
import Right2 from './right2';
import CreateGroup from './CreateGroup.vue';
import CButtons from '@/components/Basic/CButtons_separate.vue';

export default {
  components: { Left, Right1, Right2, CreateGroup, CButtons },
  data() {
    return {
      select_1: Object.freeze(['自选REITs', '自选REITs表现']),
      select_1_default: '自选REITs',
      show_left: true,
      activeName: 'first',
      TABPANEHEIGHT: '',
      ROOTFONTFIZE: '',
      nav_list: [],
      default_config: {},
      dialogVisible: false,
    };
  },
  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
        '--TABPANEHEIGHT': this.TABPANEHEIGHT + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  methods: {
    select1Change(v) {
      this.select_1_default = v;
      // localStorage.setItem('activeName', v);
    },
    toggleCreateDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    toggleLeft() {
      this.show_left = !this.show_left;
      this.$root.$emit('chartResize');
    },
    async loadGroups(index) {
      const { data } = await this.$https.get(`/api/v2/get_user_reit_groups`);
      if (data.code !== 200) return this.$message.error(data.msg);
      const nav_list = data.data.groups || [];
      this.default_config = Object.freeze(data.data.default_config || {});
      this.nav_list = nav_list.map((item, i) => ({
        ...item,
        active: i === index,
        checked: false,
        // 显示删除提示
        del_visible: false,
        edit: false,
        // 编辑用
        edit_value: item.name,
      }));
    },
    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
      this.TABPANEHEIGHT = localStorage.getItem('TABPANEHEIGHT');
    },
    /* handleClick(e) {
      localStorage.setItem('activeName', e.name);
    }, */
    // 获取股票代码2
    async fnGetCodeName2() {
      const res = await this.$https.get('api/conghua/basicInfo/list_width_userdata');

      const data = res.data.data;
      // 获取大类
      let L1 = data.map((node) => {
        return node.reitsTypeL1;
      });

      L1 = [...new Set(L1)];
      L1.unshift('公募REITs');
      L1 = L1.map((node) => {
        let obj = {
          value: node,
          label: node,
        };
        return obj;
      });

      let BIGCATEGORY = [];

      L1.forEach((node) => {
        let children = [];
        data.forEach((item) => {
          if (node.label == item.reitsTypeL1) {
            children.push(item.reitsTypeL2);
          }
        });

        children = [...new Set(children)];
        if (children.length > 0) {
          children = children.map((node) => {
            let obj = {
              value: node,
              label: node,
            };
            return obj;
          });

          let obj2 = {
            value: node.value,
            label: node.label,
            children: children,
          };

          BIGCATEGORY.push(obj2);
        } else {
          BIGCATEGORY.push(node);
        }
      });

      // 存入REITs
      let REITs = [...BIGCATEGORY];
      REITs.forEach((node) => {
        if (node.children) {
          node.children.forEach((item) => {
            item.children = [];
            data.forEach((ele) => {
              if (item.label == ele.reitsTypeL2) {
                let obj = {
                  value: ele.reitCode,
                  label: ele.reitsName,
                };
                item.children.push(obj);
              }
            });
          });
        }
      });
      // console.clear();
      localStorage.setItem('REITsNAME2', JSON.stringify(REITs));
    },
  },
  mounted() {
    // this.select_1_default = localStorage.getItem('activeName') || '自选REITs';
    this.loadGroups();
    this.fnGetWidth();
    window.addEventListener('resize', this.fnGetWidth);
    this.$root.$on('reloadCodeName2', this.fnGetCodeName2);
  },
  beforeDestroy() {
    this.$root.$off('reloadCodeName2');
    window.removeEventListener('resize', this.fnGetWidth);
  },
};
</script>

<style lang="less" scoped>
.page-content-wrap {
  position: relative;
  display: flex;
  width: calc(100% - var(--ROOTFONTFIZE) * (20 / 144));
  height: calc(var(--TABPANEHEIGHT) + var(--ROOTFONTFIZE) * (40 / 144));
  box-sizing: border-box;
  // margin-top: calc(var(--ROOTFONTFIZE) * (10 / 144));
  border-radius: 20px;
  overflow-y: auto;
  .icon-buton {
    cursor: pointer;
    position: absolute;
    z-index: 9999;
    left: calc(var(--ROOTFONTFIZE) * (10 / 144));
    bottom: calc(var(--ROOTFONTFIZE) * (6 / 144));
    font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
    font-weight: 700;
    padding: 6px;
    border-radius: 100%;
    color: var(--primary-color);
    background-color: var(--el-header-SsearchStyle-bgc);
    // transition: left 0.2s 0.1s;
    &.show {
      left: calc(var(--ROOTFONTFIZE) * (205 / 144));
    }
  }
  .left {
    box-sizing: border-box;
    background-color: var(--cascader-bgc2);
    width: 0;
    padding: 0;
    overflow: hidden;
    // transition: width 0.2s 0.1s, padding 0.2s 0.1s;
    &.show {
      padding: 12px;
      width: calc(var(--ROOTFONTFIZE) * (200 / 144));
      flex: none;
    }
  }
  .right {
    box-sizing: border-box;
    padding: 30px;
    background-color: var(--charts_bgc);
    width: 100%;
    &.show {
      width: calc(100% - var(--ROOTFONTFIZE) * (200 / 144));
    }
    .dfhdszds {
      padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
      /deep/ .container {
        margin-left: 0;
      }
    }
  }
}

// -------------------------

.home {
  background-color: var(--bigger-card-bgc);
  height: 100%;
}

// el-tabs
.el-tabs {
  background-color: var(--bigger-card-bgc);
  // padding-left: calc(var(--ROOTFONTFIZE) * (13 / 144));
}

::v-deep .el-tabs__item {
  color: var(--el_tabs_item_color);
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 400;
  letter-spacing: 0.1px;
}

::v-deep .el-tabs__item:hover {
  color: var(--el_tabs_item_color_active_hover) !important;
}

::v-deep .el-tabs__item.is-active {
  color: var(--el_tabs_item_color_active) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
}

/*去掉tabs底部的下划线*/
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

/*去掉切换时el-tab-pane底部的蓝色下划线*/
::v-deep .el-tabs__active-bar {
  // background-color: #1573fe !important;
  background-color: var(--primary-color) !important;
}

::v-deep .el-tab-pane {
  // background-color: #1573fe !important;
  display: block;
  // height: var(--TABPANEHEIGHT);
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  // padding-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
  // padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
}

// =============elmentui end ==========================================

.autoArea {
  height: auto;
  width: 100%;
}

.thityCon {
  padding: calc(var(--ROOTFONTFIZE) * (20 / 144));
}
</style>
